/**
 * Authentication Constants
 *
 * Shared constants for authentication across web and mobile platforms.
 * Part of Batch 5a migration.
 */

// Timeout configurations (in milliseconds)
export const AUTH_TIMEOUT = 60000 // 60 seconds - general auth operation timeout
export const COMPANY_ID_TIMEOUT = 30000 // 30 seconds - timeout for fetching company ID
export const SESSION_VALIDATION_COOLDOWN = 30000 // 30 seconds between session validations
export const SESSION_TIMEOUT = 15000 // 15 seconds - timeout for getSession calls

// Legal document versions - update these when documents change
export const DOCUMENT_VERSIONS = {
  PRIVACY_POLICY: '1.0',
  EULA: '1.0',
  TERMS_OF_SERVICE: '1.0',
  AI_DATA_PROCESSING: '1.0',
}

// Document type identifiers
export const DOCUMENT_TYPES = {
  PRIVACY_POLICY: 'privacy_policy',
  EULA: 'eula',
  TERMS_OF_SERVICE: 'terms_of_service',
  AI_DATA_PROCESSING: 'ai_data_processing',
}

// Document URL paths (relative to base URL)
export const DOCUMENT_PATHS = {
  privacy_policy: '/privacy',
  eula: '/eula',
  terms_of_service: '/terms',
  ai_data_processing: '/privacy#ai-data-processing',
}

// Auth event types (matching Supabase events)
export const AUTH_EVENTS = {
  SIGNED_IN: 'SIGNED_IN',
  SIGNED_OUT: 'SIGNED_OUT',
  TOKEN_REFRESHED: 'TOKEN_REFRESHED',
  USER_UPDATED: 'USER_UPDATED',
  PASSWORD_RECOVERY: 'PASSWORD_RECOVERY'
}

// Magic link cache settings
export const MAGIC_LINK_CACHE_EXPIRY = 5 * 60 * 1000 // 5 minutes

// Default expiry for magic links (in days)
export const DEFAULT_MAGIC_LINK_EXPIRY_DAYS = 30

// Consent methods for legal documents
export const CONSENT_METHODS = {
  CHECKBOX: 'checkbox',
  BUTTON: 'button',
  IMPLICIT: 'implicit',
  MODAL: 'modal',
}

// Password requirements configuration
export const PASSWORD_REQUIREMENTS = {
  MIN_LENGTH: 8,
  REQUIRE_LETTERS: true,
  REQUIRE_DIGITS: true,
  RESET_COOLDOWN_MS: 60000,
  RESET_LINK_EXPIRY_SECONDS: 3600,
}
